/* eslint-disable */
import request from '@/utils/request';

/**
 * Simple RESTful resource class
 */
class Resource {
  constructor(uri) {
    this.uri = uri;
  }
  list(query) {
    return request({
      url: '/api/' + this.uri,
      method: 'get',
      params: query,
    });
  }
  get(id) {
    return request({
      url: '/api/' + this.uri + '/' + id,
      method: 'get',
    });
  }
  store(resource) {
    return request({
      url: '/api/' + this.uri,
      method: 'post',
      data: resource,
    });
  }
  update(id, resource) {
    return request({
      url: '/api/' + this.uri + '/' + id,
      method: 'put',
      data: resource,
    });
  }
  updatepost(id, resource) {
    return request({
      url: '/api/' + this.uri + '/updatepost/' + id,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: resource,
    });
  }
  destroy(id) {
    return request({
      url: '/api/' + this.uri + '/' + id,
      method: 'delete',
    });
  }
}

export { Resource as default };
